export const SIDEBAR_WIDTH = 300
export const popupElementId = 'c-map-popover-id'

export const DEFAULT_ZOOM = 6
